import { render } from "./bill-by-sum.vue?vue&type=template&id=556180e0&scoped=true&ts=true"
import script from "./bill-by-sum.vue?vue&type=script&lang=ts"
export * from "./bill-by-sum.vue?vue&type=script&lang=ts"

import "./bill-by-sum.vue?vue&type=style&index=0&id=556180e0&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556180e0"]])

export default __exports__